import React from 'react';
import { Box, Spinner, SpinnerProps } from 'grommet';

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = (props) => (
  <Box height="100vh" fill="horizontal" justify="center" align="center">
    <Spinner size={props.size || 'medium'} {...props} />
  </Box>
);

export type LoadingSpinnerProps = SpinnerProps;
